module.exports = __webpack_public_path__ + "static/media/Insurance.bb702eec.png";